class h {
  constructor() {
    this.handlers = {};
  }
  emit(s, ...r) {
    const t = this.handlers[s] ?? [];
    for (const n of t)
      n(...r);
  }
  on(s, r) {
    return this.handlers[s] ??= [], this.handlers[s].push(r), () => {
      this.handlers[s] = (this.handlers[s] ?? []).filter(
        (t) => t !== r
      );
    };
  }
}
function i(e, s) {
  const r = new h();
  for (const [t, n] of Object.entries(s))
    e.on(
      t,
      (...o) => r.emit(n, ...o)
    );
  return r;
}
export {
  h as Bus,
  i as redirectBus
};
